import { useEffect } from "react";

export const useRefreshOnAuth = (callback) => {
  useEffect(() => {
    if (!callback) return;

    // Listen for the signal we fired in AuthForm
    window.addEventListener("session-restored", callback);

    return () => {
      window.removeEventListener("session-restored", callback);
    };
  }, [callback]);
};
